module.exports = __webpack_public_path__ + "img/fx.894f69f4.png";